import { ImageProps } from "@omni/types/components/props/image.props";
import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { Img } from "@/components/General/Image/components/img";
import { ImageContextProvider } from "@/components/General/Image/context/image.context";
import { getRenderImage } from "@/components/General/Image/helpers/renderImage.helpers";
import BreakpointsService from "@/services/breakpoint.service";
import { useImpressionTracking } from "@/utils/hooks/tracking/useImpressionTracking.hook";

export const Base = ({
    src,
    renditions,
    mobileSrc,
    mobileRenditions,
    mobileWidth,
    mobileHeight,
    width,
    height,
    className,
    children,
    trackingProps,
    intersectionOptions,
    ...props
}: ImageProps) => {
    const { ref } = useImpressionTracking(trackingProps, intersectionOptions);

    const image = getRenderImage({
        src: src,
        renditions: renditions,
        width: width,
        height: height
    });

    const mobileImage = getRenderImage({
        src: mobileSrc,
        renditions: mobileRenditions,
        width: mobileWidth,
        height: mobileHeight
    });

    if (!isDefined(image)) return;

    return (
        <ImageContextProvider
            image={image}
            mobileImage={mobileImage}
            {...props}
        >
            <picture
                ref={ref}
                className={cn("tw:w-full tw:h-auto", className)}
            >
                {isDefined(mobileImage) && (
                    <>
                        <source
                            srcSet={mobileImage.srcSet}
                            media={`(width < ${BreakpointsService.getBreakpointValuesObject().min.md}px)`}
                            width={mobileImage.width}
                            height={mobileImage.height}
                        />
                        <source
                            srcSet={image.srcSet}
                            media={`(width >= ${BreakpointsService.getBreakpointValuesObject().min.md}px)`}
                            width={image.width}
                            height={image.height}
                        />
                    </>
                )}
                {children && children}
                {!children && <Img />}
            </picture>
        </ImageContextProvider>
    );
};
